import { render, staticRenderFns } from "./hour.vue?vue&type=template&id=482d09b6&"
import script from "./hour.vue?vue&type=script&lang=ts&"
export * from "./hour.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports